import { getFeatureToggleClient } from 'infra/featureToggles'

export default function isImpersonationMfaGuardExceptionEnabled(): boolean {
  return getFeatureToggleClient().variation(
    'WorkPortal.ImpersonationMfaGuardException',
    false,
  )
}
